import { useEffect, useState } from "react";
import moment from "moment";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { generateAxiosInstanceInstitute } from "../../hooks/useAuthorizedRequestForInstitute";
import { generateAxiosInstanceSection } from "../../hooks/useAuthorizedRequestForSection";
import { useNavigate } from 'react-router-dom';
import { GeneratePdf } from "../../components/GeneratePdf";
import separator_line from "../../assets/separator_line.png";
import VidyaUpasna from "../../assets/VidyaUpasna.jpg";
import { getCurrentTime } from "../../components/CurrentTime";
import { LocalizationProvider, DatePicker, MonthCalendar } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TextField } from "@mui/material";
import Swal from "sweetalert2";
import { Loader } from "../../components/ModalsCommonFunctions";

const InstituteExamReportByTeacher = () => {
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const [teacherList, setTeacherList] = useState(null)
    const [sectionList, setSectionList] = useState([])
    const [reportData, setReportData] = useState([]);
    const [teacherDetails, setTeacherDetails] = useState(null);
    const [totalExamCountSubject, setTotalExamCountSubject] = useState([]);
    const [report, setReport] = useState(null);
    const inititalFormState = {
        section_id: '',
        teacher: '',
        from_date: moment().format('YYYY-MM'),
        to_date: moment().format('YYYY-MM')
    }

    const [sectionData, setSectionData] = useState(inititalFormState);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSectionList();
    }, []);

    const getSectionList = () => {
        const apiUrlForSection = `/get-section?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSection)
            .then(response => {
                setSectionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setSectionData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
            }
        })
    }

    const handleSectionChange = (e) => {
        const { name, value } = e.target;
        setSectionData((prevData) => {
            return {
                ...prevData,
                [name]: value,
            }
        })

        const apiUrl = `/get-teacher?instituteMasterId=${instituteMasterId}&sectionMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTeacherList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleStartMonth = (newMonth) => {
        setSectionData((prevData) => ({
            ...prevData,
            from_date: newMonth ? newMonth.format('YYYY-MM') : '',
        }));
    };

    const handleEndMonth = (newMonth) => {
        setSectionData((prevData) => ({
            ...prevData,
            to_date: newMonth ? newMonth.format('YYYY-MM') : '',
        }));
    };

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(sectionData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(sectionData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [sectionData])

    const showResult = () => {
        if (validateForm()) {
            setLoading(true);
            let apiUrl = `/section-exam-report-by-teacher?`;

            if (sectionData.teacher) {
                apiUrl += `teacherId=${sectionData.teacher}&`;
            }

            if (sectionData.from_date) {
                apiUrl += `fromDate=${sectionData.from_date}&`;
            }

            if (sectionData.to_date) {
                apiUrl += `toDate=${sectionData.to_date}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    const result = aggregateSubjectData(response.data.teacherMappedSubjects, response.data.examAssignData)
                    setTeacherDetails(response.data.teacher);
                    setTotalExamCountSubject(getTotalExamCountInEverySubject(result));
                    setReportData(result);
                    setReport(response.data);
                })
                .catch(error => {
                    setReportData({})
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        text: errorMsg
                    })
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(sectionData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const getTotalExamCountInEverySubject = (result) => {
        const totalExamCounts = [];

        result.forEach(entry => {
            entry.divisions.forEach(division => {
                division.subjects.forEach(subject => {
                    if (subject.examCount !== -1) {
                        let subjectIndex = totalExamCounts.findIndex(item => item.subjectName === subject.subjectName);
                        if (subjectIndex === -1) {
                            // If subjectName not found, add a new entry
                            totalExamCounts.push({
                                subjectName: subject.subjectName,
                                totalExamCount: subject.examCount
                            });
                        } else {
                            // If subjectName found, update totalExamCount based on conditions
                            if (totalExamCounts[subjectIndex].totalExamCount === -1) {
                                totalExamCounts[subjectIndex].totalExamCount = subject.examCount;
                            } else {
                                totalExamCounts[subjectIndex].totalExamCount += subject.examCount;
                            }
                        }
                    }
                });
            });
        });

        // Calculate allSubjectExamCount
        const allSubjectExamCount = totalExamCounts.reduce((sum, subject) => {
            if (subject.totalExamCount !== -1) {
                return sum + subject.totalExamCount;
            }
            return sum;
        }, 0);

        // Add allSubjectExamCount to totalExamCounts
        const totalExamCountSubject = {
            totalExamCounts: totalExamCounts,
            allSubjectExamCount: allSubjectExamCount
        };

        return totalExamCountSubject;
    }

    const getUniqueSubjects = (teacherMappedSubjects) => {
        const uniqueSubjects = teacherMappedSubjects.reduce((acc, curr) => {
            if (!acc.some(subject => subject.id === curr.instituteSubjectMasterDetails.id)) {
                acc.push({
                    id: curr.instituteSubjectMasterDetails.id,
                    subjectName: curr.instituteSubjectMasterDetails.subjectName
                });
            }
            return acc;
        }, []);

        return uniqueSubjects;
    }

    const aggregateSubjectData = (teacherMappedSubjects, examAssignData) => {
        const uniqueSubjects = getUniqueSubjects(teacherMappedSubjects);
        const result = [];

        teacherMappedSubjects.forEach(mappedSubject => {
            const subject_id = mappedSubject.instituteSubjectMasterDetails.id;
            const subjectName = mappedSubject.instituteSubjectMasterDetails.subjectName;
            const gradeName = mappedSubject.instituteGradeMasterDetails.gradeName;
            const divisionName = mappedSubject.instituteDivisionMasterDetails.divisionName;

            let isFound = false;

            for (let i = examAssignData.length - 1; i >= 0; i--) {
                const exam = examAssignData[i];
                if (gradeName === exam.InstituteGradeMaster.gradeName) {
                    for (let j = exam.ExamAssignDivisions.length - 1; j >= 0; j--) {
                        const examWiseDivision = exam.ExamAssignDivisions[j];
                        if (divisionName === examWiseDivision.InstituteDivisionMaster.divisionName) {
                            isFound = true;

                            // Find or initialize the result entry
                            let resultEntryIndex = result.findIndex(r => r.gradeName === gradeName);

                            if (resultEntryIndex === -1) {
                                // Initialize new result entry if not found
                                const resultEntry = {
                                    gradeName,
                                    divisions: [{
                                        divisionName,
                                        subjects: uniqueSubjects.map(subject => ({
                                            id: subject.id,
                                            subjectName: subject.subjectName,
                                            examCount: subject.id === exam.subject_id ? 1 : -1
                                        }))
                                    }]
                                };
                                result.push(resultEntry);
                                resultEntryIndex = result.length - 1;
                            } else {
                                // Find the correct division index based on divisionName
                                let divisionIndex = result[resultEntryIndex].divisions.findIndex(d => d.divisionName === divisionName);

                                if (divisionIndex === -1) {
                                    // Initialize new division if not found
                                    divisionIndex = result[resultEntryIndex].divisions.push({
                                        divisionName,
                                        subjects: uniqueSubjects.map(subject => ({
                                            id: subject.id,
                                            subjectName: subject.subjectName,
                                            examCount: subject.id === exam.subject_id ? 1 : -1
                                        }))
                                    }) - 1;
                                } else {
                                    // Update subjects count for matched subject
                                    let subjectIndex = result[resultEntryIndex].divisions[divisionIndex].subjects.findIndex(sub => sub.id === exam.subject_id);

                                    if (subjectIndex !== -1) {
                                        // Subject exists, increment examCount
                                        if (result[resultEntryIndex].divisions[divisionIndex].subjects[subjectIndex].examCount === -1) {
                                            result[resultEntryIndex].divisions[divisionIndex].subjects[subjectIndex].examCount = 1;
                                        } else {
                                            result[resultEntryIndex].divisions[divisionIndex].subjects[subjectIndex].examCount += 1;
                                        }
                                    } else {
                                        // Subject not found, add new subject with examCount 1
                                        result[resultEntryIndex].divisions[divisionIndex].subjects.push({
                                            id: exam.subject_id,
                                            subjectName: uniqueSubjects.find(subject => subject.id === exam.subject_id)?.subjectName || '',
                                            examCount: 1
                                        });
                                    }
                                }
                            }

                            // Remove the division or the whole exam
                            if (examWiseDivision.InstituteDivisionMaster.length > 1) {
                                examWiseDivision.InstituteDivisionMaster.splice(j, 1);
                            } else {
                                examAssignData.splice(i, 1);
                            }
                        }
                    }
                }
            }

            // If not found, initialize the result entry with examCount 0 for the matched subject
            if (!isFound) {
                let resultEntryIndex = result.findIndex(r =>
                    r.gradeName === gradeName
                );

                if (resultEntryIndex === -1) {
                    const resultEntry = {
                        gradeName,
                        divisions: [{
                            divisionName,
                            subjects: uniqueSubjects.map(subject => ({
                                id: subject.id,
                                subjectName: subject.subjectName,
                                examCount: subject.id === subject_id ? 0 : -1
                            }))
                        }]
                    };
                    result.push(resultEntry);
                } else {
                    const resultEntry = result[resultEntryIndex];
                    let divisionIndex = resultEntry.divisions.findIndex(div => div.divisionName === divisionName);

                    if (divisionIndex === -1) {
                        divisionIndex = resultEntry.divisions.push({
                            divisionName,
                            subjects: uniqueSubjects.map(subject => ({
                                id: subject.id,
                                subjectName: subject.subjectName,
                                examCount: subject.id === subject_id ? 0 : -1
                            }))
                        }) - 1;
                    } else {
                        resultEntry.divisions[divisionIndex].subjects.forEach(subject => {
                            if (subject.id === subject_id && subject.examCount === -1) {
                                subject.examCount = 0;
                            }
                        });
                    }

                    result[resultEntryIndex] = resultEntry; // Update the result array entry
                }
            }
        });

        result.forEach(grade => {
            grade.divisions.forEach(division => {
                let subjectExamCount = 0;
                division.subjects.forEach(subject => {
                    if (subject.examCount !== -1) {
                        subjectExamCount += subject.examCount;
                    }
                });
                division.subjectExamCount = subjectExamCount;
            });
        });

        return result;
    }

    const handleInputReset = () => {
        setSectionData(inititalFormState);
        setTotalExamCountSubject([]);
        setError(initialErrorState);
        setTeacherDetails(null);
        setReportData([]);
        setReport(null);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>

                        <li className="breadcrumb-item active"><span>Report By Teacher</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-person-chalkboard"></i>Report By Teacher</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="section_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Section</label>
                                                    <select class="form-select" aria-label="Default select example" name='section_id' onChange={handleSectionChange} value={sectionData.section_id} >
                                                        <option selected value={''} disabled>Select Section</option>
                                                        {
                                                            sectionList?.map((section) => {
                                                                return <option value={section.id}>{section.sectionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.section_id && <p style={{ color: 'red' }}>{error.section_id}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="teacher" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Teacher</label>
                                                    <select class="form-select" aria-label="Default select example" name='teacher' onChange={handleInputChange} value={sectionData.teacher} >
                                                        <option selected value={''} disabled>Select Teacher</option>
                                                        {
                                                            teacherList?.map((teacher) => {
                                                                return <option value={teacher.id}>{teacher.teacherName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.teacher && <p style={{ color: 'red' }}>{error.teacher}</p>}
                                                </div>

                                                <div className="col-md-6 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>From Date</label>
                                                    {/* <input type="date" className="form-control" id="result_publish_date" name='from_date' onChange={handleInputChange} value={sectionData.from_date} /> */}
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(sectionData.from_date)}
                                                            onChange={handleStartMonth} // Use the month picker handler here
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    {error.from_date && <p style={{ color: 'red' }}>{error.from_date}</p>}
                                                </div>

                                                <div className="col-md-6 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>To Date</label>
                                                    {/* <input type="date" className="form-control" id="result_publish_date" name='to_date' onChange={handleInputChange} value={sectionData.to_date} /> */}
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(sectionData.to_date)}
                                                            onChange={handleEndMonth} // Use the month picker handler here
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    {error.to_date && <p style={{ color: 'red' }}>{error.to_date}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    <button className="btn btn-primary" type="button" onClick={showResult}>Show</button>
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                </div>

                                                {sectionData.section_id.length !== 0 && sectionData.teacher.length !== 0 && sectionData.from_date.length !== 0 && sectionData.to_date.length !== 0 && reportData.length !== 0 &&
                                                    (<>
                                                        <div className="separator"></div>
                                                        {reportData && reportData.length !== 0 ? (
                                                            <>
                                                                <GeneratePdf id="examReportContent" />
                                                                <div className="d-grid gap-2 mt-2">
                                                                    <div class="report_block" id="examReportContent">
                                                                        <div class="heading">
                                                                            <div class="logo">
                                                                                <img src={teacherDetails.instituteMasterDetails.logoPath} alt="" />
                                                                            </div>
                                                                            <div class="text_center">
                                                                                <h6>{teacherDetails?.instituteMasterDetails?.instituteName}</h6>
                                                                                <h4>{teacherDetails?.sectionMasterDetails?.sectionName}</h4>
                                                                            </div>
                                                                            <div class="logo">
                                                                                <img src={VidyaUpasna} alt="" />
                                                                            </div>
                                                                        </div>
                                                                        <div class="report_code text_center">
                                                                            <img src={separator_line} alt="" className="line" />
                                                                            <span className="txt">Exam Report</span>
                                                                        </div>
                                                                        <div class="exam_report">
                                                                            <span class="table_caption">Name of Report : Exams By Teacher</span>
                                                                            <table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th rowspan="2">Sr no.</th>
                                                                                        <th rowspan="2">Teacher Name</th>
                                                                                        <th colspan="2">Date</th>
                                                                                        <th colspan={totalExamCountSubject?.totalExamCounts?.length}>Name of Subject</th>
                                                                                        <th rowspan="2">Total</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th>From</th>
                                                                                        <th>To</th>
                                                                                        {totalExamCountSubject?.totalExamCounts?.map((subject, index) => (
                                                                                            <th key={index}>{subject.subjectName}</th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>1</td>
                                                                                        <td>{teacherDetails?.teacherName}</td>
                                                                                        <td>{report.fromDate}</td>
                                                                                        <td>{report.toDate}</td>
                                                                                        {totalExamCountSubject?.totalExamCounts?.map((subject, index) => (
                                                                                            <td key={index}>{subject.totalExamCount === -1 ? "Not Assign" : subject.totalExamCount}</td>
                                                                                        ))}
                                                                                        <td>{totalExamCountSubject.allSubjectExamCount}</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div class="analysis_report">
                                                                            <span class="table_caption">Report Analysis : Divisionwise Exam</span>
                                                                            <table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th rowspan="2">Sr No</th>
                                                                                        <th rowspan="2">Class</th>
                                                                                        <th rowspan="2">Division</th>
                                                                                        <th colspan={totalExamCountSubject?.totalExamCounts?.length}>Name of Subject</th>
                                                                                        <th rowspan="2">Total</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        {totalExamCountSubject?.totalExamCounts?.map((subject, index) => (
                                                                                            <th key={index}>{subject.subjectName}</th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        reportData.length > 0 &&
                                                                                        reportData.map((grade, index) => (
                                                                                            <>
                                                                                                <tr>
                                                                                                    <td rowspan={grade.divisions.length}>{index + 1}</td>
                                                                                                    <td rowspan={grade.divisions.length}>{grade.gradeName}</td>

                                                                                                    <td>{grade.divisions[0].divisionName}</td>
                                                                                                    {
                                                                                                        grade.divisions[0].subjects.map((subject, index) => (
                                                                                                            <td>{subject.examCount === -1 ? "Not Assign" : subject.examCount}</td>
                                                                                                        ))
                                                                                                    }
                                                                                                    <td>{grade.divisions[0].subjectExamCount}</td>

                                                                                                </tr>

                                                                                                {
                                                                                                    grade.divisions.slice(1).map((division, index) => (
                                                                                                        <>
                                                                                                            <tr>
                                                                                                                <td>{division.divisionName}</td>
                                                                                                                {
                                                                                                                    division.subjects.map((subject, index) => (
                                                                                                                        <td>{subject.examCount === -1 ? "Not Assign" : subject.examCount}</td>
                                                                                                                    ))
                                                                                                                }
                                                                                                                <td>{division.subjectExamCount}</td>
                                                                                                            </tr>
                                                                                                        </>
                                                                                                    ))
                                                                                                }
                                                                                            </>
                                                                                        ))
                                                                                    }

                                                                                </tbody>
                                                                                <tfoot>
                                                                                    <tr>
                                                                                        <th colspan="3" class="text_right">Total</th>
                                                                                        {
                                                                                            totalExamCountSubject.totalExamCounts.map((data) => (
                                                                                                <th>{data.totalExamCount}</th>
                                                                                            ))
                                                                                        }
                                                                                        <th>{totalExamCountSubject.allSubjectExamCount}</th>
                                                                                    </tr>
                                                                                </tfoot>
                                                                            </table>
                                                                        </div>

                                                                        <div class="report_footer">
                                                                            <div>
                                                                                <span>{getCurrentTime()}</span>
                                                                                <span>Time stamp of export</span>
                                                                            </div>
                                                                            <div>
                                                                                <span>{teacherDetails?.teacherName}</span>
                                                                                <span>Name of Class Teacher</span>
                                                                            </div>
                                                                            <div>
                                                                                <span>{teacherDetails?.sectionMasterDetails.sectionInchargeName}</span>
                                                                                <span>Section Incharge Name</span>
                                                                            </div>
                                                                            <div>
                                                                                <span>{teacherDetails?.instituteMasterDetails.inchargeName}</span>
                                                                                <span>Institute Head Name</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="text-center" style={{ padding: "50px", fontWeight: 'bold' }}>
                                                                No Result Available
                                                            </div>
                                                        )}
                                                    </>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteExamReportByTeacher;